import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import { CSVLink} from "react-csv";

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ErrorsOrWarningsList from './List';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import { sanitizeCsvData } from '../../utils/csvSanitizer';

const log = new Logger('ERRORS_WARNINGS_EXPORT_PANEL', LOG_LEVELS.DEBUG);

const headers = [
  {label: "Invoice number", key: "invoiceNumber"},
  {label: "Description", key: "message"}
]
export class ErrorsAndWarningsExportPanel extends Component {
  render() {
    log.debug('render: ', this.props);
    return (
      <div>
          <ErrorsOrWarningsList
            elementIdToUse="export-errors-table"
            type={'Errors/Warnings for export'}
            list={this.props.list}
            onFieldChange={() => {}}
            actionHandler={() => {}}
            setFieldValues={() => {}}
            fieldValues={[]}
            formInitialising={false}
            disableSelectors={true}
          />
          <div className="clear"></div>
          <hr />

          <CSVLink
            filename={this.props.filename}
            className="button primary"
            data={sanitizeCsvData(_.isArray(this.props.list) ? this.props.list : [])}
            headers={headers}
          >
              <span><LanguageStringResolver string={'errorsAndWarnings_SaveAs'}/> {this.props.filename}</span>
          </CSVLink>
      </div>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(ErrorsAndWarningsExportPanel);
